import React, {useEffect, useRef} from "react";
import {components, OptionProps} from 'react-select';
import FontAwesome from 'react-fontawesome';
import {EntryDescColorHoverLine} from "module/edesc/component/EntryDescColorHoverLine";
import {EntryDesc} from 'generated/JavaTOmodifications'
import {EntryDescCustomProps} from 'module/edesc/component/EntryDescCustomProps'
import {getEntryDescStyleObj} from 'module/edesc/EntryDescUtil'
import {css} from '@emotion/react'
import {EntryDescShortLabelComponent} from 'module/edesc/component/EntryDescShortLabelComponent'

const cssShortLabel = css`
	padding: 2px;
	border-radius: 4px;
`
const cssText = css`
	display: inline-block;
	min-width: 100px;
`
const cssOption = css`
	display: grid;
	align-items: center;
	justify-content: start;
	gap: 8px;
	padding: 4px;
`
const cssOptionDefault = css`
	grid-template-columns: max-content 1fr max-content max-content;
`
const cssOptionFavEdit = css`
	user-select: none;
	grid-template-columns: max-content max-content 1fr;
`
const cssIcon = css`
	padding: 0 8px;
	width: 18px;
`
const cssSelectedIcon = css`
	justify-self: end;
`

export function EntryDescSelectOption({children, ...props}: OptionProps<EntryDesc, false> & { selectProps: EntryDescCustomProps }) {
	const {entryDescFavEditMode, toggleEntryDescFav, entryDescFavIds} = props.selectProps;
	const entryDesc = props.data;
	const style = getEntryDescStyleObj(entryDesc)
	const ref = useRef<null | HTMLDivElement>(null)
	useEffect(() => {
		if (ref.current) {
			ref.current.scrollIntoView({block: "center", inline: "nearest"})
		}
	}, [ref.current])
	const typeComponent = <>
		<EntryDescShortLabelComponent css={cssShortLabel} entryDesc={entryDesc}/>
		<div css={cssText}>{entryDesc.text}</div>
		{entryDesc.icon && <div css={cssIcon}><FontAwesome name={entryDesc.icon}/></div>}
	</>
	if (entryDescFavEditMode) {
		const isFav = entryDescFavIds.includes(entryDesc.id);
		return (
			<EntryDescColorHoverLine entryDesc={entryDesc} onClick={() => toggleEntryDescFav({entryDescId: entryDesc.id})}>
				<div css={[cssOption, cssOptionFavEdit]}>
					<FontAwesome name={isFav ? 'star' : 'star-o'}/>
					{typeComponent}
				</div>
			</EntryDescColorHoverLine>
		)
	} else {
		return (
			<components.Option {...props}>
				<div css={[cssOption, cssOptionDefault]} style={props.isSelected || props.isFocused ? style : undefined}>
					{typeComponent}
					{props.isSelected && <>
						<FontAwesome name={'check'} css={cssSelectedIcon}/>
						<span ref={ref}/>
					</>}
				</div>
			</components.Option>
		)
	}
}